import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ProductTypeService } from '@http/clients/product-type.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-opportunity-product-types-form-editor',
    templateUrl: './report-opportunity-product-types-form-editor.component.html',
    styleUrls: ['./report-opportunity-product-types-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportOpportunityProductTypesFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportOpportunityProductTypesFormEditorComponent
    extends FormEditorBase<number[] | null>
    implements OnInit
{
    readonly = input<boolean>(false);
    labelText = input<string>('Opportunity Product Types');
    placeholderText = input<string>('Select Product Types');

    private readonly productTypeService = inject(ProductTypeService);

    async ngOnInit(): Promise<void> {
        const types = await this.productTypeService.search({
            filterText: undefined,
            isActive: true,
            isReserved: undefined
        });
        this.items.set(types);
        this.selectedItems.set(this.mapValueToSelectedItems(this.selectedValue() ?? null));
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
